import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEventRevertCancelOrderRequestEvent } from "../../../common/types/order-details-history-entry-event";

type OrderDetailsHistoryEntryRevertCancelOrderRequestContentProps = {
  event: OrderDetailsHistoryEventRevertCancelOrderRequestEvent;
};

const OrderDetailsHistoryEntryRevertCancelOrderRequestContentComponent: FC<
  OrderDetailsHistoryEntryRevertCancelOrderRequestContentProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .revertCancelOrderRequestEntry;

  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryRevertCancelOrderRequestContentComponent;
